<div class="menu">
    <ul class="menu__list">
        <div *ngFor="let item of menu;">
            <mapfre-auditlib-menu-item [item]="item" (clicked)="onItemClicked($event)"></mapfre-auditlib-menu-item>
        </div>
    </ul>
</div>